<template>
<div>
  <div @click="showModal = true">
    <slot name="trigger"></slot>
  </div>
  <div class="modal-mask" v-if="showModal" transition="modal" @click="showModal = false">
    <div class="modal-wrapper">
      <div class="modal-container modal-transition-container" @click.stop>
        <div class="modal-body">
          <slot name="content"></slot>
        </div>
        <div class="modal-footer">
          <button class="btn" @click.stop="cancel">{{ cancelLabel }}</button>
          <button class="btn btn-primary" @click.stop="ok">{{ confirmLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// Generic OK/Cancel modal component

export default {
  props: [
    'cancelLabel', 'confirmLabel'
  ],
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    ok: function () {
      this.showModal = false
      this.$emit('confirm')
    },
    cancel: function () {
      this.showModal = false
      this.$emit('cancel')
    }
  }
}
</script>
